import {useSnackbar, SnackbarMessage, SnackbarKey, VariantType, OptionsObject} from 'notistack';
import React from "react";
import {IconProps} from "../components/icons";

interface CustomSnackbarProps {
    enqueueSnackbar: EnqueueSnackbar;
    closeSnackbar: (key?: SnackbarKey) => void,
}

export type EnqueueSnackbar = {
    (options: NotificationParams): SnackbarKey;
};

export type OurVariantType = VariantType | 'primary' | 'ai'

export interface NotificationParams extends Omit<OptionsObject, 'variant'> {
    message: SnackbarMessage;
    title?: SnackbarMessage;
    variant?: OurVariantType;
    Icon?: React.ComponentType<IconProps>;
    isCloseIcon?: boolean
    actionDef?: {
        text: string,
        onClick: () => void,
    }
}

export const useNotification = (): CustomSnackbarProps => {
    const {enqueueSnackbar: originalEnqueueSnackbar, closeSnackbar} = useSnackbar();

    const enqueueSnackbarWithCustomCode: EnqueueSnackbar = (
        options: NotificationParams
    ) => {
        // @ts-ignore
        return originalEnqueueSnackbar(options);
    };

    return {
        enqueueSnackbar: enqueueSnackbarWithCustomCode,
        closeSnackbar: closeSnackbar,
    };
};
